import { NextCmsCookieDisclaimer } from "./NextCMSCookieDisclaimer";
import { COMPANION_APP_USER_AGENT } from "./PageHeader";
import GdprStorage from "../../app/uidispatcherapi/GdprStorage";

type CookieDisclaimerProps = {
	hasCountrySiteCoreURL: boolean;
};

const CookieDisclaimer = ({ hasCountrySiteCoreURL }: CookieDisclaimerProps) => {
	if (hasCountrySiteCoreURL) {
		if (window.loggedInViaBearerToken === true) {
			return null;
		}

		if (
			navigator.userAgent.includes(COMPANION_APP_USER_AGENT) &&
			GdprStorage.cookie.get("allowedCookieCategories").actualResult
		) {
			return null;
		}

		return <NextCmsCookieDisclaimer />;
	}

	return null;
};

export { CookieDisclaimer };
